var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Banner'),_c('Accelerate'),_c('ReasonChose'),_c('Install'),_c('Product'),_c('div',{staticClass:"footer"},[_vm._v("2018-2020 Transgle. All rights reserved")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }